/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminCompleteMultipart,
  AdminCreateMultiPartUpload,
  AdminCreateUploadUrl,
  PresignedMultipart,
  PresignedUrl
} from '.././model';

import adminV1OrganizationsUploadsCompleteMultipartCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsUploadsUploadUrlCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsUploadsUploadUrlMultipartCreateMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Complete a multipart upload for the organization's storage.
 * @summary Complete a multipart upload for the organization's storage.
 */
export const adminV1OrganizationsUploadsCompleteMultipartCreate = (
    organizationId: number,
    adminCompleteMultipart: AdminCompleteMultipart,
 options?: SecondParameter<typeof adminV1OrganizationsUploadsCompleteMultipartCreateMutator<void>>,) => {
      return adminV1OrganizationsUploadsCompleteMultipartCreateMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/uploads/complete_multipart/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCompleteMultipart
    },
      options);
    }
  /**
 * Generate a signed URL for uploading a file to the organization's storage.
 * @summary Generate a signed URL for uploading a file to the organization's storage.
 */
export const adminV1OrganizationsUploadsUploadUrlCreate = (
    organizationId: number,
    adminCreateUploadUrl: AdminCreateUploadUrl,
 options?: SecondParameter<typeof adminV1OrganizationsUploadsUploadUrlCreateMutator<PresignedUrl>>,) => {
      return adminV1OrganizationsUploadsUploadUrlCreateMutator<PresignedUrl>(
      {url: `/api/admin/v1/organizations/${organizationId}/uploads/upload_url/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateUploadUrl
    },
      options);
    }
  /**
 * Generate signed URLs for uploading a file in multiple parts to the organization's storage.
 * @summary Generate signed URLs for uploading a file in multiple parts to the organization's storage.
 */
export const adminV1OrganizationsUploadsUploadUrlMultipartCreate = (
    organizationId: number,
    adminCreateMultiPartUpload: AdminCreateMultiPartUpload,
 options?: SecondParameter<typeof adminV1OrganizationsUploadsUploadUrlMultipartCreateMutator<PresignedMultipart>>,) => {
      return adminV1OrganizationsUploadsUploadUrlMultipartCreateMutator<PresignedMultipart>(
      {url: `/api/admin/v1/organizations/${organizationId}/uploads/upload_url_multipart/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateMultiPartUpload
    },
      options);
    }
  export type AdminV1OrganizationsUploadsCompleteMultipartCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsUploadsCompleteMultipartCreate>>>
export type AdminV1OrganizationsUploadsUploadUrlCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsUploadsUploadUrlCreate>>>
export type AdminV1OrganizationsUploadsUploadUrlMultipartCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsUploadsUploadUrlMultipartCreate>>>
